<template>
 <div @click="onClick">
       <div class="inline field">
        <label> ID: </label>
        <span>{{rowData.id}}</span>
      </div>
      <div class="inline field">
        <label>GUID: </label>
        <span>{{rowData.guid}}</span>
      </div>
      <div class="inline field">
        <label>File Location Data Path: </label>
        <span>{{rowData.FileLocationDataPath}}</span>
      </div>
      <div class="inline field">
        <label>Original File Name: </label>
        <span>{{rowData.OrigFileName}}</span>
      </div>
</div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onClick (event) {
            console.log('DocumentHistoryDetails: on-click', event.target)
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/integration-history/DocumentHistoryDetails.vue